import { useFormik } from "formik";
import React, {useState, useEffect, ForwardRefRenderFunction} from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { updateCleaner } from "sr/utils/api/cleaner/updateCleaner";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import AutoLocation from "sr/helpers/ui-components/AutoLocation";
import { CleanerComponentProps } from './CleanerComponentProps'
import { forwardRef } from "react";
import { getCleaner } from "sr/utils/api/cleaner/getCleaner";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { createRecipient } from "sr/utils/api/cleaner/trolley/createRecipient";
import { getRecipient } from "sr/utils/api/cleaner/trolley/getRecipient";
import * as Yup from "yup";

const cleanerAddressSchema = Yup.object({
  address: Yup.object({
    address_line_1: Yup.string()
      .trim()
      .required("INPUT.VALIDATION.ADDRESS.ADDRESS.LINE1"),
    country: Yup.string().required("INPUT.VALIDATION.AUTOLOCATION.COUNTRY"),
    state: Yup.string().required("INPUT.VALIDATION.ADDRESS.ADDRESS.STATE"),
    city: Yup.string().trim().required("INPUT.VALIDATION.ADDRESS.ADDRESS.CITY"),
    postal: Yup.string()
      .trim()
      .required("INPUT.VALIDATION.ADDRESS.ADDRESS.ZIPCODE")
      .max(9, "INPUT.VALIDATION.ZIP.CODE.VALID"),
  })
    .required("INPUT.VALIDATION.ADDRESS.ADDRESS.LINE1")
    .typeError("INPUT.VALIDATION.ADDRESS.ADDRESS.LINE1"),
});

const CleanerPersonalInfo: ForwardRefRenderFunction<any, CleanerComponentProps> = (
  { HandleStepper = null, page = '', type = '',dataAddedHandle=null, id='',cleanerDetails = {} },
  ref
) => {
  const [address, setAddress] = useState(null)
  const [userData, setUserData] = useState(null)
  const [cleanerData, setCleanerData] = useState<any>()
  const [loader, setLoader] = useState<string>('')
  const [isrecipient, setIsRecipient] = useState(false)  
  const intl = useIntl()
  const HandleAutoLocation = (data:any) =>{
    setAddress(data)
  }

  useEffect(()=> {
    const getdetails = getUserDetails()
    setUserData(getdetails)
    
  },[])
  useEffect(()=> {
console.log(cleanerData)
  },[cleanerDetails, cleanerData])
    const fetchRecipient = async (userId)=>{
        
        try {
        const queryParams = new URLSearchParams()
        if (userId) queryParams.append('user_id', userId)
          const res = await getRecipient(queryParams)
        if(res?.success===true){
            if(res?.data && res?.data !==null && res?.data !== undefined){
              setIsRecipient(true)
            }
        }
        else{
        }
      }
      catch(e){
      }
      }
      useEffect(()=>{
          if(userData?.user_id){
            fetchRecipient(userData?.user_id)
          }
      },[userData?.user_id])

const initialValues = {
        id:page ==='popup' ? id: userData?.user_id,
        regionId:address?.regionId,
        address: address || {
          address_line_1: "",
          address_line_2: "",
          country: "",
          state: "",
          city: "",
          postal: "",
        }
}

useEffect(()=> {
  const fetchData = async () => {
    const queryParams = new URLSearchParams()
    queryParams.append('id',id )
    setLoader('fetch')
    try {
      const cleanerData = await getCleaner(queryParams)
      if(cleanerData?.success===true){
        setCleanerData(cleanerData?.data)
        setLoader('')
      }
    }
    catch(e:any){
      
    }
  }
  if(page === 'popup' && type==='put'){
  fetchData()
  }   
  
},[id])

useEffect(()=>{
  if(cleanerDetails?.address){
    setAddress(cleanerDetails?.address)
  }
},[cleanerDetails?.address])

  const {values, errors, handleChange, handleSubmit, submitForm } = useFormik({
    initialValues: initialValues,
    enableReinitialize:true,
    validationSchema: cleanerAddressSchema,
    onSubmit: async (values) => {
      setLoader('submit')
      try {
      const result = await updateCleaner(values)
        if(result.success===true) {
          if (HandleStepper !== null) {
            SuccessMessage('API.SUCCESS.CLEANER.PERSONAL.DETAILS.ADD')
            const payloadtrolley = {
              firstName:result?.data?.first_name,
              lastName:result?.data?.last_name,
              email:result?.data?.email,
              type:'individual',
              user_id:result?.data?.id,
              address:{
                street1:result?.data?.address?.address_line_1,
                city:result?.data?.address?.city,
                country:result?.data?.address?.country,
                // postalCode:result?.data?.address?.postal
              }
            }
            if(isrecipient===true){
              HandleStepper(1);
              return
            }
            try {
            const res = await createRecipient(payloadtrolley)
            }
            catch(e){

            }
            finally{
            
          HandleStepper(1);
            }

          }
          if(page === 'popup' ){
            SuccessMessage('API.SUCCESS.CLEANER.UPDATE')
            dataAddedHandle(true)
            }
            setLoader('')
        
       }
      }
      catch(e:any){
        setLoader('')
      }
    },
  });
  React.useImperativeHandle(ref, () => ({
    submitForm,
  }));
  useEffect(()=>{
    // Error handling effect
  },[errors])
  return (
    <>
    {loader==='submit' && <LoaderFullScreen />}
      <ContentWithSpinner loader={loader==='fetch'}>
      <form onSubmit={handleSubmit} className="mt-5">
        <AutoLocation
          restrictregionchange={false}
          isHideLatLang={true}
          HandleAutoLocation={HandleAutoLocation}
          address={cleanerDetails?.address || cleanerData?.address}
          errors={errors?.address || {}}
        />
        {page === 'popup' && type==='put' ? '':(
       <div className='mt-5 flex justify-center lg:justify-start'>
                    <button type='submit'
                      className='rounded-full
                                bg-[#ff39b3] font-bold
                                p-2
                                text-white
                                w-44
                                cursor-pointer
                                hover:bg-navy'
                      ><FormattedMessage id="REGISTER.BUTTON.SAVEANDCONTINUE" defaultMessage="Save and Continue" />
                    </button>
                  </div>
        )}
      </form>
      </ContentWithSpinner>
    </>
  );
}

export default forwardRef(CleanerPersonalInfo);
